export const DEFAULT_DEBOUNCE_MS = 250
export const MIN_INPUT_LENGTH = 2
